"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadData = downloadData;
exports.uploadData = uploadData;
const DataStorageManager_1 = __importDefault(require("../../data/DataStorageManager"));
// global array update -> json file -> create url & save to local  
function downloadData() {
    const data = DataStorageManager_1.default.getData();
    const json = JSON.stringify(data, null, 2);
    const blob = new Blob([json], { type: "application/json" });
    const fileName = prompt("Enter File Name", "Chord-Sheet");
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    if (fileName) {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${fileName}.json`; // 加上 .json 副檔名
        a.click();
        URL.revokeObjectURL(url);
    }
    else {
        alert("下載已取消，因為沒有提供檔案名稱。");
    }
}
// 主上傳函數，用於處理文件上傳並解析 JSON
function uploadData() {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".json"; // 限制只能上傳 .json 文件
    input.click();
    input.addEventListener("change", handleFileSelection);
}
function handleFileSelection(event) {
    const input = event.target;
    const file = input.files ? input.files[0] : null;
    if (file) {
        // 當選擇了文件後，調用 readFile 來讀取文件內容
        readFile(file);
    }
}
// 讀取文件並解析 JSON
function readFile(file) {
    const reader = new FileReader();
    reader.onload = (e) => handleFileLoad(e);
    reader.readAsText(file);
}
// 處理文件讀取完成事件，解析 JSON 並更新到 DataStorageManager
function handleFileLoad(event) {
    var _a;
    try {
        const data = JSON.parse((_a = event.target) === null || _a === void 0 ? void 0 : _a.result);
        processData(data);
    }
    catch (error) {
        alert("Invalid JSON file format.");
    }
}
// 處理並更新數據到 DataStorageManager
function processData(data) {
    if (Array.isArray(data)) {
        // DataStorageManager.clearData();
        data.forEach((item) => {
            if (item.id) {
                DataStorageManager_1.default.updateData(item.id, item);
            }
            else {
                console.warn("Item is missing an ID and will be skipped:", item);
            }
        });
        DataStorageManager_1.default.applyDataToDOM();
        console.log("Data uploaded successfully");
    }
    else {
        throw new Error("Invalid JSON format");
    }
}
